import { EBillingPlanCode } from '@/contexts/billingContext/domain/constants';
import { useTenantsStore } from '@/stores/tenants';
import { getIsCustomCargoOwnerPlanCode } from '@/contexts/billingContext/domain/getIsCustomCargoOwnerPlanCode';

// Отображаем блок если:
// - есть активная подписка тарифа НЕ cargoOwner
// - нет активной подписки И нет запланированной подписки тарифа cargoOwner

export const getIsBillingInfoBlockShown = (): boolean => {
  const tenantsStore = useTenantsStore();

  const subscriptionRequest = tenantsStore.currentTenantDetails?.subscriptionRequest || null;
  const activeSubscription = tenantsStore.getActiveSubscription;
  const pendingSubscription = tenantsStore.getPendingSubscription;

  const hasCargoOwnerActiveSubscription = activeSubscription?.planCode === EBillingPlanCode.cargoOwner
    || getIsCustomCargoOwnerPlanCode(activeSubscription?.planCode);

  const hasCargoOwnerExpectedSubscription = subscriptionRequest?.planCode === EBillingPlanCode.cargoOwner
    || pendingSubscription?.planCode === EBillingPlanCode.cargoOwner
    || getIsCustomCargoOwnerPlanCode(pendingSubscription?.planCode);

  return (!!activeSubscription && !hasCargoOwnerActiveSubscription)
      || (!activeSubscription && !hasCargoOwnerExpectedSubscription);
};
